import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaCheck, FaWhatsapp } from "react-icons/fa";
import supportImg from "../../image/medi.png";
import "../../css/appointmentModal.css";
import { useNavigate } from "react-router-dom";
function AppointmentModal({ show, onHide }) {
  const [result, setResult] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setResult("");

    const formData = new FormData(event.target);
    const dataObj = Object.fromEntries(formData.entries());
    dataObj.subject = "New Enquiry from Appointment Modal";

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataObj)
      });

      const data = await response.json();

      if (data.success) {
        onHide();
        navigate("/thank-you");
      } else {
        console.log("Error", data);
        setResult("Something went wrong while submitting your enquiry. Please try again.");
      }
    } catch (error) {
      setResult("Something went wrong while submitting your enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        size="xl"
        dialogClassName="custom-appointment-modal"
        contentClassName="border-0 bg-transparent"
      >
        <div className="modal-wrapper position-relative d-flex shadow overflow-hidden">

          <img src={supportImg} alt="Support" className="bg-person-img" />

          {/* Close Button */}
          <button
            onClick={onHide}
            className="btn-close-custom position-absolute rounded-circle shadow-sm d-flex align-items-center justify-content-center bg-white"
          >
            &times;
          </button>

          {/* Left Side Content */}
          <div className="modal-left position-relative p-4 p-md-5 d-none d-md-flex flex-column" style={{ flex: "1 1 40%", minHeight: "550px", overflow: "hidden" }}>

            <div className="position-relative z-1 mb-5 pt-3">
              <h2 className="fw-bolder mb-4" style={{ color: "#0b1528", fontSize: "32px", lineHeight: "1.2" }}>
                Get Expert Pharma Consultation at Best Prices
              </h2>

              <div className="d-inline-block text-white fw-bold px-4 py-2 rounded-3 mb-3" style={{ backgroundColor: "#1e88e5", fontSize: "14px" }}>
                Chemo Biological provides expert<br /> business support
              </div>
              <br />
              <div className="d-inline-flex align-items-center text-primary px-3 py-2 rounded-pill fw-bold" style={{ fontSize: "13px", backgroundColor: "#e3f2fd" }}>
                <FaCheck className="me-2" /> 100% Quality Guaranteed
              </div>
            </div>

            <div className="position-relative z-1 mt-auto">
              <p className="fw-bold text-dark mb-2" style={{ fontSize: "15px", color: "white !important" }}>Chat with us on</p>
              <a href="https://wa.me/917827552889" target="_blank" rel="noreferrer" className="btn bg-white text-dark fw-bold rounded-pill shadow-sm px-4 py-2 d-inline-flex align-items-center text-decoration-none" style={{ fontSize: "17px" }}>
                <FaWhatsapp className="text-success fs-5 me-2" /> +91 7827552889
              </a>
            </div>
          </div>

          {/* Right Side Form Panel */}
          <div className="modal-right p-3 p-md-5 position-relative d-flex align-items-center justify-content-center" style={{ flex: "1 1 60%", zIndex: 2 }}>
            <div className="form-card p-3 p-md-4 p-lg-5 w-100 rounded-4">
              <form onSubmit={onSubmit}>
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label fw-bold text-dark" style={{ fontSize: "12px" }}>Full Name <span className="text-danger">*</span></label>
                    <input type="text" name="name" className="form-control form-control-sm py-2 custom-input" placeholder="Enter your full name" required />
                  </div>
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label fw-bold text-dark" style={{ fontSize: "12px" }}>Email Address</label>
                    <input type="email" name="email" className="form-control form-control-sm py-2 custom-input" placeholder="Enter your email" pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" title="Please enter a valid email address" required />
                  </div>
                </div>

                {/* <div className="mb-4">
                <label className="form-label fw-bold text-dark" style={{ fontSize: "12px" }}>Service Selection</label>
                <select className="form-select form-select-sm py-2 custom-input" name="service">
                  <option>Select Service</option>
                  <option>PCD Pharma Franchise</option>
                  <option>Third Party Manufacturing</option>
                  <option>General Inquiry</option>
                </select>
              </div> */}

                <div className="mb-3">
                  <label className="form-label fw-bold text-dark" style={{ fontSize: "12px" }}>Phone <span className="text-danger">*</span></label>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-white custom-input border-end-0 text-muted" style={{ fontSize: "13px" }}>IN <i className="bi bi-chevron-down ms-1" style={{ fontSize: "10px" }}></i></span>
                    <span className="input-group-text bg-white custom-input border-start-0 border-end-0 px-2 fw-semibold text-dark" style={{ fontSize: "13px" }}>+91</span>
                    <input type="tel" name="phone" className="form-control py-2 custom-input border-start-0" placeholder="" pattern="[0-9]{10}" maxLength="10" minLength="10" title="Please enter a valid 10-digit phone number" required />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold text-dark" style={{ fontSize: "12px" }}>City</label>
                  <input type="text" name="city" className="form-control py-2 custom-input" placeholder="" required />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold text-dark" style={{ fontSize: "12px" }}>Message</label>
                  <textarea name="message" className="form-control py-2 custom-input" rows="2" placeholder="Tell us about your requirements..."></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="btn btn-warning w-100 py-2 fw-bold text-dark rounded-3 shadow-sm mb-2" style={{ fontSize: "14px" }}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                {result && <div className="text-center small mt-2 fw-bold text-danger">{result}</div>}
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AppointmentModal;
